module.exports = __webpack_public_path__ + "img/shield-tick.3fc74b9f.svg";